import script from "./SubjectPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubjectPage.vue?vue&type=script&setup=true&lang=js"

import "./SubjectPage.vue?vue&type=style&index=0&id=9e08f1c8&lang=css"

const __exports__ = script;

export default __exports__